export const PRIMARY_CTA_CLASS =
  'inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-[#5865F2] via-[#4752C4] to-[#5865F2] text-white font-medium rounded-lg hover:shadow-lg hover:shadow-[#5865F2]/30 transition-all duration-300';

export const SECONDARY_CTA_CLASS =
  'inline-flex items-center justify-center px-6 py-3 bg-white/5 border border-white/20 text-white font-medium rounded-lg hover:bg-white/10 transition-all duration-300';

export const TEXT_LINK_CLASS =
  'text-sm text-[#9BA8FF] underline underline-offset-4 hover:text-white transition-colors';

export const OFFER_FORM_PATH = '/contact?service=site-web&offre=site-pro';
export const ECOMMERCE_FORM_PATH = '/contact?service=site-web';
